import { Autocomplete, DialogActions, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import { useEditIMetadataTagZonesStore } from "./editIMetadataTagZonesStore/editIMetadataTagZonesStore";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { getNumbersAfterEditCamera } from "../EditCamera/EditCamera";

export const AddMetaDataIgnoreZoneDialog = () => {
  const {
    addMetaDataIgnoreZoneDialogOpen,
    setAddMetaDataIgnoreZoneDialogOpen,
    metadataTagZones,
    metricLabels,
    setSelectedMetadataTagZone,
    setEditorVisible,
    shapeColor,
    newMetadataTagZone,
    setNewMetadataTagZone,
  } = useEditIMetadataTagZonesStore();

  return (
    <Dialog
      open={addMetaDataIgnoreZoneDialogOpen}
      onClose={() => setAddMetaDataIgnoreZoneDialogOpen(false)}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>Add Metadata Ignore Zone</DialogTitle>
      <DialogContent sx={{ height: "390px" }}>
        <div className="pt-[10px]">
          <TextField
            label="Name"
            variant="standard"
            value={newMetadataTagZone.name}
            onChange={(event) => {
              setNewMetadataTagZone({
                ...newMetadataTagZone,
                name: event.target.value,
              });
            }}
            sx={{ width: 395 }}
            helperText=""
            type="string"
          />
        </div>
        <div className="pt-[30px]">
          <Autocomplete
            multiple
            disablePortal
            options={metricLabels}
            value={metricLabels.filter((metric) =>
              newMetadataTagZone.metric_labels.includes(metric.id)
            )}
            onChange={(event, value) => {
              setNewMetadataTagZone({
                ...newMetadataTagZone,
                metric_labels: value.map((metric) => metric.id), // Extract IDs
              });
            }}
            getOptionLabel={(option) => option.display_name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            sx={{ width: 395 }}
            renderInput={(params) => (
              <TextField {...params} variant="standard" label="Metrics" />
            )}
          />
        </div>
        <div className="pt-[40px]">
          <TextField
            label="Description"
            multiline
            rows={4}
            value={newMetadataTagZone.description}
            onChange={(event) => {
              setNewMetadataTagZone({
                ...newMetadataTagZone,
                description: event.target.value,
              });
            }}
            sx={{ width: 395 }}
            helperText="Optional"
            type="string"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => setAddMetaDataIgnoreZoneDialogOpen(false)}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setAddMetaDataIgnoreZoneDialogOpen(false);
            setSelectedMetadataTagZone({
              // Don't include id property - let API assign it
              camera: Number(getNumbersAfterEditCamera(location.href)), // Use actual camera ID from URL
              name: newMetadataTagZone.name,
              description: newMetadataTagZone.description,
              line_color: shapeColor,
              coordinates: newMetadataTagZone.coordinates,
              metric_labels: newMetadataTagZone.metric_labels,
            });
            setEditorVisible(true);
          }}
          text="Add"
          disabled={!newMetadataTagZone.name}
        />
      </DialogActions>
    </Dialog>
  );
};
